import React, {Component} from 'react';
import { isMobileBrowser } from '../../../lib/Helpers';

class Event extends Component {
  render() {

	// As per https://www.digitalocean.com/community/tutorials/7-ways-to-implement-conditional-rendering-in-react-applications
	const renderDesktopImage = () => {
		if(!isMobileBrowser) {
          return (<div className="image"><img src={this.props.image_medium} alt={`${this.props.title} image`} /></div>)
		}
	}

    return (

      <div className="detail-content">

		{renderDesktopImage()}

        <div className="scroll-pane">

          <h3 className="title">
            {this.props.title}
          </h3>

          {this.props.description &&
          <div className="description">
            {this.props.description}

            <div className="link">
              <a href={`https://www.vam.ac.uk/exhibitions/${this.props.slug}`} data-tracking-mapwhatson="V&A What's on">More details</a>
            </div>
          </div>
          }

        </div>

      </div>
    )
  }
}

export default Event;
